// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-editor {
  height: 100%;
}

.ql-editor-disabled {
  border-radius: 6px;
  background-color: rgba(124, 0, 0, 0.2);
  transition-duration: 0.5s;
}

.ql-editor.ql-blank::before {
  font-style: normal;
}

/* Remove border when hideBorder prop is true */
.editor-no-border .ql-container.ql-snow {
  border: none !important;
}

.editor-no-border .ql-container {
  border: none !important;
}

.editor-no-border .ql-editor {
  border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/editor.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".ql-editor {\n  height: 100%;\n}\n\n.ql-editor-disabled {\n  border-radius: 6px;\n  background-color: rgba(124, 0, 0, 0.2);\n  transition-duration: 0.5s;\n}\n\n.ql-editor.ql-blank::before {\n  font-style: normal;\n}\n\n/* Remove border when hideBorder prop is true */\n.editor-no-border .ql-container.ql-snow {\n  border: none !important;\n}\n\n.editor-no-border .ql-container {\n  border: none !important;\n}\n\n.editor-no-border .ql-editor {\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
